import LocationsCard from './LocationsCard';

export default LocationsCard;
